var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.$route.path,"background-color":"#545c64","text-color":"#fff","active-text-color":"#ffd04b"}},_vm._l((_vm.routersList),function(route,index){return _c('MenuItem',{key:index,attrs:{"item":route,"fatherPath":route.path}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e24d49d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ElMenu/index.vue
// module id = null
// module chunks = 